import * as tslib_1 from "tslib";
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { ConfigActions } from '../../ThemeOptions/store/config.actions';
import { ThemeOptions } from '../../theme-options';
export class BaseLayoutComponent {
    constructor(globals, configActions) {
        this.globals = globals;
        this.configActions = configActions;
    }
    toggleSidebarMobile() {
        this.globals.toggleSidebarMobile = !this.globals.toggleSidebarMobile;
    }
}
tslib_1.__decorate([
    select('config'),
    tslib_1.__metadata("design:type", Observable)
], BaseLayoutComponent.prototype, "config$", void 0);
